var Vendd = (function (Vendd) {
    'use strict';

    var state = {
        ItemId: LhApp.Context.Item.Id
    };

    var getStoresForm = function (data) {
        var request = {};

        request = { ...state, ...data };

        var options = {
            url: 'StoresService.svc/GetStoresForm',
            data: request,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess (response) {
            var model = response;
            state = { ...state, ...data };

            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.UpdateForm(model));
        };

        function onFailure (response) {
            console.log(response);
        };

        Vendd.Service.call(options);
    };

    var calculateDistances = function (data, sender) {
        var sourcePoint = data.source.trim();
        data.DistanceMeasured = false;
        data.TotalFindInRange = 0;
    	try {            
    		if (sourcePoint.length === 5 && parseInt(sourcePoint) > 9999) {
    			sourcePoint = "greece+" + sourcePoint;
    		} else if (sourcePoint.length === 0) {
    			sourcePoint = "athens";
    		}

    		var origin = sourcePoint;
            var destinations = [];
            var index = 0;
            for (var group = 0; group < data.array.length; group++) {
                for (var i = 0; i < data.array[group].Items.length; i++ , index++) {
                    var elem = data.array[group].Items[i];
                    destinations[index] = new google.maps.LatLng(parseFloat(elem.Latitude.trim()), parseFloat(elem.Longitude.trim()));
                }
            }

    		var service = new google.maps.DistanceMatrixService();
    		service.getDistanceMatrix(
			  {
			  	origins: [origin],
			  	destinations: destinations,
			  	travelMode: 'DRIVING',
			  	unitSystem: google.maps.UnitSystem.METRIC
			  }, onSuccess);
    	} catch (ex) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.CalculateDistancesSuccess(data, sender));
    		console.log(ex);
    	}
    	function onSuccess(response, status) {
            if (data) {
                try {
                    var index = 0;
                    var withinRange = 0;
                    for (var group = 0; group < data.array.length; group++) {
                        for (var i = 0; i < data.array[group].Items.length; i++ , index++) {
                            var distance;
                            var distanceString = "";
                            var duration;
                            var durationString = "";
                            var warehouse = data.array[group].Items[i];
                            var elem = response.rows[0].elements[index];
                            if (elem.status === "OK") {
                                distance = elem.distance.value;
                                distanceString = elem.distance.text;
                                duration = elem.duration.value;
                                durationString = elem.duration.text;
                            } else {
                                distance = Number.MAX_SAFE_INTEGER;
                            }
                            if (distance && distance <= data.maxDistance) {
                                withinRange++;
                                warehouse.IsWithinRange = true;
                                //isWithinRange = true;
                            } else {
                                warehouse.IsWithinRange = false;
                                //isWithinRange = false;
                            }
                            warehouse.Distance = distance;
                            warehouse.DistanceString = distanceString;
                            warehouse.Duration = duration;
                            warehouse.DurationString = durationString;
                        }
                    }
                    data.DistanceMeasured = true;
                    data.TotalFindInRange = withinRange;
                } catch (ex) {
                    data.DistanceMeasured = false;
                }
            }
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.CalculateDistancesSuccess(data, sender));
    	};

    };

    Vendd.Store.Controller = (function () {
        var initialized = false;

        return {
            initState: function (initialState) {
                if (initialized === true) {

                    return state;
                } else {

                    state = { ...state, ...initialState };

                    initialized = true;

                    return state;
                }
            },
            getState: function () {
                return state;
            }
        };
    })();

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.resetFilters, Vendd.Store, function () {
        var data = {
            CountryCode: "",
            Continent: "",          
            City: "",
            Area: "",
            TypeId: 0,
            SearchTerm: "",          
            PostCode: ""
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.resetLocationFilters, Vendd.Store, function () {
        var data = {
            CountryCode: "",
            Continent: "",           
            City: "",
            Area: ""
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetContinent, Vendd.Store, function (envelope) {
        var data = {         
            CountryCode: "",
            Continent: envelope.message.data.continent,
            City: "",
            Area: "",
            TypeId: 0
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetCountry, Vendd.Store, function (envelope) {
        var data = {
            CountryCode: envelope.message.data.country,
            City: "",
            Area: "",
            TypeId: 0
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetCity, Vendd.Store, function (envelope) {
        var data = {
            City: envelope.message.data.city,
            Area: "",
            TypeId: 0
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetArea, Vendd.Store, function (envelope) {
        var data = {
            Area: envelope.message.data.area,
            TypeId: 0
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SetType, Vendd.Store, function (envelope) {
        var data = {
            TypeId: envelope.message.data.type
        };

        getStoresForm(data);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.CalculateDistances, Vendd.Store, function (envelope) {
        calculateDistances(envelope.message.data, envelope.sender);
    });
    
    Vendd.MessageBus.subscribe(Vendd.Store.Messages.GetCountries, Vendd.Store, function (envelope) {
        var options = {
            url: 'api/StoreLocator/GetCountries',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.GetCountriesSuccess(response.data));
		}

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.GetCountriesFailure(response.data));
		}

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.SearchResults, Vendd.Store, function (envelope) {
        var options = {
            url: 'api/StoreLocator/SearchPOI',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.SearchResultsSuccess(response.data));
		}

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.SearchResultsFailure(response.data));
		}

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.QueryPartners, Vendd.Store, function (envelope) {
        var options = {
            url: 'api/StoreLocator/QueryPartners',
            data: envelope.message.data.model,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.QueryPartnersSuccess(response.data));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Store, new Vendd.Store.Messages.QueryPartnersFailure(response.data));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});